import { useEffect } from "react";
import api from "@/utils/api";
import { useBrandLogos } from "@/contexts/BrandLogoContext";
import { brandInitials, getStaticBrandLogoSrc, normalizeBrand } from "@/utils/format";

export default function StockBrandLogo({ brand, className = "", presentation, srcOverride = "" }) {
  const { logos, ensureLogos } = useBrandLogos();
  useEffect(() => { ensureLogos(); }, [ensureLogos]);
  const normalized = normalizeBrand(brand);
  const custom = presentation || logos[normalized];
  const customLogoSrc = custom?.image_url ? `${api.defaults.baseURL}${custom.image_url}` : "";
  const logoSrc = srcOverride || customLogoSrc || getStaticBrandLogoSrc(normalized);
  const hasLogo = Boolean(logoSrc);
  const scale = Number(custom?.scale ?? 1);
  const offsetX = Number(custom?.offset_x ?? 0);
  const offsetY = Number(custom?.offset_y ?? 0);

  return (
    <div
      className={`relative w-[76px] h-[52px] shrink-0 rounded-xl border border-slate-200 bg-white overflow-hidden flex items-center justify-center shadow-sm ${className}`}
      title={brand || "Diğer marka"}
      aria-label={`${brand || "Diğer"} marka logosu`}
    >
      <span className="px-2 text-center text-[11px] leading-tight font-extrabold tracking-wide text-slate-500 uppercase">
        {hasLogo ? brandInitials(brand) : (brand || "Diğer")}
      </span>
      {hasLogo && <img src={logoSrc} alt="" aria-hidden="true" loading="lazy" className="absolute inset-0 w-full h-full object-contain p-2.5 bg-white" style={{ transform: `translate(${offsetX}px, ${offsetY}px) scale(${scale})` }} onLoad={(event) => { event.currentTarget.style.display = "block"; }} onError={(event) => { event.currentTarget.style.display = "none"; }} />}
    </div>
  );
}
